import type { Category } from '$lib/types/category';

export type DrawerNavbarType = Category & { dropdown: boolean };

export const DRAWER_NAVBAR: DrawerNavbarType[] = [
  {
    name: 'Home',
    path: '/',
    enabled: true,
    dropdown: false,
    rank: 0
  },
  {
    name: 'News',
    path: '/news',
    enabled: true,
    dropdown: true,
    rank: 1
  },
  {
    name: 'Games',
    path: '/games',
    enabled: true,
    dropdown: true,
    rank: 2
  },
  {
    name: 'Horoscope',
    path: '/horoscope',
    enabled: true,
    dropdown: false,
    rank: 3
  },
  {
    name: 'Sports',
    path: '/sports',
    enabled: false,
    dropdown: false,
    rank: 4
  },
  {
    name: 'Weather',
    path: '/weather',
    enabled: false,
    dropdown: false,
    rank: 5
  },
  {
    name: 'Deals',
    path: '/deals',
    enabled: false,
    dropdown: false,
    rank: 6
  },
  {
    name: 'Bookmarks',
    path: '/bookmarks',
    enabled: true,
    dropdown: false,
    rank: 7
  }
];

export const CATEGORY_NAVBAR: Category[] = [
  {
    name: 'Home',
    path: '/',
    enabled: true,
    rank: 0
  },
  {
    name: 'News',
    path: '/news',
    enabled: true,
    rank: 1
  },
  {
    name: 'Games',
    path: '/games',
    enabled: true,
    rank: 2
  }
];

export const CATEGORY_NAVBAR_DROPDOWN: { [key: string]: { name: string; href: string }[] } = {
  News: [
    { name: 'Top News', href: '/news/top-news' },
    { name: 'Videos', href: '/news/videos' },
    { name: 'Politics', href: '/news/politics' },
    { name: 'Business', href: '/news/business' },
    { name: 'Technology', href: '/news/technology' },
    { name: 'Entertainment', href: '/news/entertainment' },
    { name: 'Sports', href: '/news/sports' }
  ],
  Games: [
    { name: 'Popular', href: '/games/popular' },
    { name: 'Puzzle', href: '/games/puzzle' },
    { name: 'Casual', href: '/games/casual' },
    { name: 'Action', href: '/games/action' }
  ]
};

export const US_NAVBAR_SECTIONS: string[] = [
  'Election Updates',
  'President',
  'Senate',
  'House',
  'Ballot Initiatives',
  'Governor'
];

export const US_ELECTION_AP_SECTIONS: string[] = [
  'President',
  'Senate',
  'House',
  'Ballot Initiatives',
  'Governor'
];
